import type { CSSProperties, ReactNode } from 'react';
import { ApiRequestError } from '../api/client';
import { t } from '../i18n/pt-BR';

/** Estados obrigatórios de toda tela: carregando, vazio, erro do Datasul e (depois) conflito de versão. */

export function Skeleton({ height = 16, width = '100%' }: { height?: number; width?: number | string }) {
  const style: CSSProperties = { height, width };
  return <div className="skeleton" style={style} aria-hidden="true" />;
}

export function LoadingBlock({ rows = 3 }: { rows?: number }) {
  return (
    <div role="status" aria-live="polite" aria-busy="true" style={{ display: 'grid', gap: 10 }}>
      <span className="sr-only">{t.states.loading}</span>
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} height={i === 0 ? 28 : 16} width={i === 0 ? '40%' : '100%'} />
      ))}
    </div>
  );
}

export function EmptyState({
  title,
  children,
  action,
}: {
  title: string;
  children?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <section className="state">
      <h2>{title}</h2>
      {children ? <p>{children}</p> : null}
      {action}
    </section>
  );
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const apiError = error instanceof ApiRequestError ? error : undefined;
  const message =
    apiError?.code === 'DATASUL_UNAVAILABLE'
      ? t.states.datasulDown
      : (apiError?.message ?? t.states.datasulDown);
  return (
    <section className="state error" role="alert">
      <h2>{t.states.errorTitle}</h2>
      <p>{message}</p>
      {onRetry ? (
        <button type="button" className="btn ghost" onClick={onRetry}>
          {t.states.retry}
        </button>
      ) : null}
    </section>
  );
}
